module.exports = __webpack_public_path__ + "static/EC_Cryptonomics-c18c9f851ba732f58bb680f56e1baa73.pdf";